import { Card, createStyles, makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React from "react";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      borderRadius: 5,
      height: 250,
      width: 150,
      background: "#fff",
      margin: 15,
      display: "flex",
      flexDirection: "column",
      color: "#c4c4c4",
    },
  })
);
interface CatalogLoaderProps {
  length?: number;
}
export function CatalogLoader({ length = 10 }: CatalogLoaderProps) {
  const styles = useStyles();
  return (
    <>
      {Object.keys(Array.from(Array(length))).map((e) => (
        <Card className={styles.root} key={e}>
          <Skeleton variant="rect" height={150} width={150} />
          <Skeleton variant="text" height={10} width={150} />
          <Skeleton variant="rect" height={100} width={150} />
          <Skeleton variant="text" height={10} width={150} />
        </Card>
      ))}
    </>
  );
}
